<template>
    <b-modal id="modal-shipping-info" size="lg" modal-class="modal-shipping modal-fullscreen" centered scrollable hide-footer>
        <template #modal-header>
            <div class="d-flex align-items-center">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="30px" height="30px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
                     xml:space="preserve">
                    <g>
                        <path d="M612,327.56v-21.606c0-10.533-4.213-20.628-11.701-28.037L484.107,162.958c-7.384-7.306-17.352-11.403-27.739-11.403
                            h-58.622v-21.988c0-16.336-13.243-29.58-29.58-29.58H29.58C13.243,99.987,0,113.23,0,129.567V327.56H612z M432.551,190.303
                            c0-2.563,2.071-4.634,4.635-4.634h21.396c1.184,0,2.366,0.494,3.253,1.282l91.006,86.865c3.057,2.86,0.986,7.987-3.154,7.987
                            h-112.5c-2.563,0-4.635-2.07-4.635-4.634V190.303z M612,343.903v65.486c0,16.336-13.243,29.578-29.579,29.578h-31.65
                            c-5.719-39.242-39.539-69.412-80.357-69.412c-40.721,0-74.54,30.17-80.259,69.412h-160.42
                            c-5.718-39.242-39.538-69.412-80.259-69.412c-40.721,0-74.541,30.17-80.259,69.412H29.58C13.243,438.968,0,425.726,0,409.39
                            v-65.486H612z M470.456,389.313c-33.883,0-61.351,27.467-61.351,61.35s27.469,61.35,61.351,61.35s61.35-27.467,61.35-61.35
                            S504.339,389.313,470.456,389.313z M470.456,481.339c-16.941,0-30.675-13.734-30.675-30.676s13.732-30.674,30.675-30.674
                            c16.941,0,30.676,13.732,30.676,30.674S487.397,481.339,470.456,481.339z M149.464,389.313c-33.883,0-61.35,27.467-61.35,61.35
                            s27.468,61.35,61.35,61.35s61.35-27.467,61.35-61.35S183.346,389.313,149.464,389.313z M149.464,481.339
                            c-16.941,0-30.676-13.734-30.676-30.676s13.734-30.674,30.676-30.674c16.941,0,30.675,13.732,30.675,30.674
                            S166.405,481.339,149.464,481.339z"/>
                    </g>
                </svg>
                <div class="modal-header-title text-uppercase ml-2 ml-md-3">Opções de entrega</div>
            </div>
            <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('modal-shipping-info')">×</button>
        </template>
        <div class="shipping product-shipping modal-shipping">
            <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
                <form action="#" method="post" @submit.prevent="handleSubmit(listShippingProduct)">
                    <ValidationProvider name="CEP" :rules="{ required: true, regex: /^\d{5}-?\d{3}$/ }" tag="div" v-slot="{ errors, classes, required }">
                        <div class="row">
                            <div class="input-group col-sm-8 col-lg-5">
                                <the-mask
                                    type="tel"
                                    class="form-control"
                                    id="cep"
                                    name="cep"
                                    :class="classes"
                                    v-model="new_cep"
                                    :mask="['#####-###']"
                                    :masked="true"
                                    style="min-height: 40px;"
                                />
                                <div class="input-group-append">
                                    <button type="submit" class="btn-default">
                                        {{ sending_cep ? "Consultando" : "ALTERAR CEP" }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                        <small v-show="shipping_msg" class="text-danger" v-html="shipping_msg"></small>
                    </ValidationProvider>
                </form>
            </ValidationObserver>
        </div>
        <div class="modal-shipping-cep-info my-4" v-if="cep_info.cep">
            <svg class="modal-shipping-pin" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 293.334 293.334" style="enable-background:new 0 0 293.334 293.334;"
                 xml:space="preserve">
                    <g>
                        <g>
                            <path style="fill:#010002;" d="M146.667,0C94.903,0,52.946,41.957,52.946,93.721c0,22.322,7.849,42.789,20.891,58.878
                                c4.204,5.178,11.237,13.331,14.903,18.906c21.109,32.069,48.19,78.643,56.082,116.864c1.354,6.527,2.986,6.641,4.743,0.212
                                c5.629-20.609,20.228-65.639,50.377-112.757c3.595-5.619,10.884-13.483,15.409-18.379c6.554-7.098,12.009-15.224,16.154-24.084
                                c5.651-12.086,8.882-25.466,8.882-39.629C240.387,41.962,198.43,0,146.667,0z M146.667,144.358
                                c-28.892,0-52.313-23.421-52.313-52.313c0-28.887,23.421-52.307,52.313-52.307s52.313,23.421,52.313,52.307
                                C198.98,120.938,175.559,144.358,146.667,144.358z"/>
                            <circle style="fill:#010002;" cx="146.667" cy="90.196" r="21.756"/>
                        </g>
                    </g>
                </svg>
            <span v-if="cep_info.cep"> CEP {{ cep_info.cep }}, </span>
            <span v-if="cep_info.logradouro"> {{ cep_info.logradouro }}, </span>
            <span v-if="cep_info.bairro"> {{ cep_info.bairro }} - </span>
            <span v-if="cep_info.cidade"> {{ cep_info.cidade }}</span>
            <span v-if="cep_info.uf" class="text-uppercase"> / {{ cep_info.uf }} </span>
        </div>
        <b-container class="pb-4">
            <b-row v-for="shipping_item in shipping_list" :key="shipping_item.id" class="modal-shipping-line-shipping pt-3">
                <b-col cols="8" md="6" class="pl-0 pr-0">
                    <div class="form-check pl-0">
                        <label
                            class="form-check-label shipping-options modal-shipping-name-shipping"
                            :for="'shipping' + shipping_item.id"
                            v-html="shipping_item.label ? shipping_item.label : shipping_item.nome_frete"
                        ></label>
                        <div class="shipping_description">
                            <div class="shipping-options mb-3" v-html="shipping_item.descricao"></div>
                            <div class="form-group" v-if="parseInt(shipping_item.id_tipo) === 2">
                                <select name="carrier" :id="'carrier' + shipping_item.id"
                                        v-model="carrier[shipping_item.id]"
                                        class="form-control shipping-form-control modal-shipping-select mt-3">
                                    <option value="" disabled>Selecione</option>
                                    <option :value="parseInt(opcao.id)"
                                            v-for="opcao in shipping_item.lista_valores" :key="opcao.id">
                                        {{ opcao.nome }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="4" md="6" class="text-right mb-3">
                    <div v-if="parseInt(shipping_item.id_tipo) === 2 && carrier[shipping_item.id]" class="modal-shipping-price">
                        <b v-if="parseFloat(shipping_item.lista_valores[carrier[shipping_item.id]].valor)">{{ shipping_item.lista_valores[carrier[shipping_item.id]].valor | currency }}</b>
                        <b v-else class="shipping-price">Grátis</b>
                    </div>
                    <div v-else-if="shipping_item.id_tipo == 2"></div>
                    <div v-else-if="parseFloat(shipping_item.valor_frete) === 0">
                        <b class="shipping-price">Grátis</b>
                    </div>
                    <div v-else class="shipping-price">
                        <b>{{ shipping_item.valor_frete | currency }}</b>
                    </div>
                    <div class="delivery_period" v-if="parseInt(shipping_item.dias_frete) > 0">
                        {{ shipping_item.dias_frete_exibicao }}
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import {TheMask} from "vue-the-mask";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            TheMask,
        },
        props: {
            cep: {
                type: String,
                default: ''
            },
            product_code: {
                type: String,
                default: ''
            },
            product_qty: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                carrier: {},
                new_cep: '',
                sending_cep: false,
                cep_info: [],
                shipping_list: [],
                shipping_msg: ''
            }
        },
        methods: {
            async listShippingProduct() {
                let msg_invalid = 'Não foi possível consultar opções de entrega, por favor entre em contato'
                try {
                    this.sending_cep = true;
                    this.shipping_list = []
                    this.cep_info = []
                    const params = new URLSearchParams();
                    params.append('metodo', 'consulta_frete');
                    params.append('cep_info', 'sim');
                    params.append('tipo', 'produto');
                    params.append('cep', this.new_cep);
                    params.append('codigo_produto', Buffer.from(this.product_code).toString('base64'));
                    params.append('quantidade', this.product_qty);
                    this.$axios.$post(`/?p=ecommerce_fretes_api_v1`, params)
                        .then((res) => {
                            this.sending_cep = false;
                            if (typeof res === 'object') {
                                this.shipping_msg = 'Sem opções de entrega, por favor entre em contato'
                                this.shipping_list = []
                                if (typeof res.list === 'object') {
                                    this.shipping_msg = '';
                                    for (let prop in res.list) {
                                        if (!(prop in this.carrier)) {
                                            // this.$set(this.carrier, prop, '')
                                        }
                                    }
                                    this.shipping_list = res.list
                                    this.cep_info = res.cep_info
                                    this.$emit('cep_changed', this.new_cep)
                                }
                                if (!('cep' in res.cep_info)) {
                                    this.shipping_msg = 'Endereço não encontrado';
                                }
                            } else {
                                this.shipping_msg = msg_invalid
                            }
                        })
                        .catch((e) => {
                            this.sending_cep = false;
                            this.shipping_msg = msg_invalid
                        })
                } catch (error) {
                    console.error(error)
                    this.sending_cep = false;
                    this.shipping_msg = msg_invalid
                }
            }
        },
        mounted() {
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if (modalId === 'modal-shipping-info') {
                    this.new_cep = this.cep
                    this.listShippingProduct()
                }
            })
        }
    }
</script>
